import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { logging } from '@heimdall/core-common';
import { FirebaseFactory } from '@heimdall/core-common-client';
import { withRouter } from 'react-router-dom';
import localForage from 'localforage';
import { db } from '@heimdall/core-common-client';
var logger = logging.instantiateLogger('heimdall:app:core:contexts:FirebaseAuthContext');
var config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};
export var x = config;

function instantiateFireauth() {
  var log = logger.extend('instantiateFireauth');
  log('Insantiating Firebase App');
  FirebaseFactory.app.instantiate(config).fold(function (err) {
    log(err);
    throw err;
  }, function (app) {
    return app;
  });
  log('Insantiating Firebase Auth');
  var fireauth = FirebaseFactory.auth.instantiate().fold(function (err) {
    log(err);
    throw err;
  }, function (auth) {
    return auth;
  });
  log('Enabling Auth local persistence');
  FirebaseFactory.auth.setLocalPersistence(fireauth);
  return fireauth;
}

var fireauth = instantiateFireauth();
var firestore = db.Firestore.connect().fold(function (err) {
  throw err;
}, function (a) {
  return a;
});
firestore.enablePersistence().catch(function (err) {
  console.log(err.code);

  if (err.code == 'failed-precondition') {} else if (err.code == 'unimplemented') {}
});
export var defaultFirebaseAuthContext = {
  authStatusReported: false,
  user: null,
  uid: undefined,
  oid: '',
  isUserSignedIn: function isUserSignedIn() {
    console.log('Not Implemented');
  },
  signInWithEmail: function signInWithEmail() {
    console.log('Not Implemented');
  },
  signOut: function signOut() {
    console.log('Not Implemented');
  },
  setOrganizationId: function setOrganizationId() {
    console.log('Not Implemented');
  }
};
export var FirebaseAuthContext = React.createContext(defaultFirebaseAuthContext);
export var FirebaseAuthConsumer = FirebaseAuthContext.Consumer;

var FirebaseAuthProviderClass =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FirebaseAuthProviderClass, _React$Component);

  function FirebaseAuthProviderClass(props) {
    var _this;

    _classCallCheck(this, FirebaseAuthProviderClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FirebaseAuthProviderClass).call(this, props));

    _this.unsubscribe = function () {};

    _this.setOrganizationId = function (oid) {
      console.log('done it again');
      console.log(oid);

      _this.setState({
        uid: 'test'
      });
    };

    _this.state = {
      authStatusReported: false,
      user: null,
      uid: undefined,
      oid: '',
      isUserSignedIn: function isUserSignedIn() {
        console.log(!!_this.state.user);
        return !!_this.state.user;
      },
      signInWithEmail: function () {
        var _signInWithEmail = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(username, password) {
          var loginResult;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return fireauth.signInWithEmailAndPassword(username, password);

                case 3:
                  loginResult = _context.sent;
                  console.log(loginResult);
                  _context.next = 10;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);

                  if (_context.t0.code = 'auth/wrong-password') {
                    console.log(_context.t0);
                  } else {
                    console.log(_context.t0);
                  }

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));

        function signInWithEmail(_x, _x2) {
          return _signInWithEmail.apply(this, arguments);
        }

        return signInWithEmail;
      }(),
      signOut: function () {
        var _signOut = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return localForage.clear();

                case 3:
                  _context2.next = 8;
                  break;

                case 5:
                  _context2.prev = 5;
                  _context2.t0 = _context2["catch"](0);
                  console.log(_context2.t0);

                case 8:
                  fireauth.signOut();

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 5]]);
        }));

        function signOut() {
          return _signOut.apply(this, arguments);
        }

        return signOut;
      }(),
      setOrganizationId: _this.setOrganizationId
    };
    return _this;
  }

  _createClass(FirebaseAuthProviderClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.unsubscribe = fireauth.onAuthStateChanged(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(user) {
          var doc, userData;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!user) {
                    _context3.next = 12;
                    break;
                  }

                  _context3.next = 3;
                  return firestore.collection('users').doc(user.uid).get();

                case 3:
                  doc = _context3.sent;
                  userData = doc.data();

                  if (!userData) {
                    _context3.next = 9;
                    break;
                  }

                  _this2.setState({
                    authStatusReported: true,
                    user: user,
                    uid: user.uid,
                    oid: userData['active_org']
                  });

                  _context3.next = 10;
                  break;

                case 9:
                  throw new Error('User data not found');

                case 10:
                  _context3.next = 13;
                  break;

                case 12:
                  _this2.setState({
                    authStatusReported: true,
                    user: user
                  });

                case 13:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var authStatusReported = this.state.authStatusReported;
      return React.createElement(FirebaseAuthContext.Provider, {
        value: this.state
      }, authStatusReported && children);
    }
  }]);

  return FirebaseAuthProviderClass;
}(React.Component);

export var FirebaseAuthProvider = withRouter(FirebaseAuthProviderClass);